var _rect, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "Customer support icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 120,
    height: 120,
    rx: 18,
    fill: "#1e1e2e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 58a8 8 0 0 1 8-8h56a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H62l-14 12v-12h-12a8 8 0 0 1-8-8z",
    fill: "#4a90e2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 68,
    r: 4,
    fill: "#1e1e2e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 68,
    r: 4,
    fill: "#1e1e2e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 68,
    r: 4,
    fill: "#1e1e2e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.35b84e4b6e81ca4b53ef4957628d8319.svg";
export { ForwardRef as ReactComponent };